import Cookies from "js-cookie";
import { csrfFetch } from "./csrf.js";
import { authServerUrl, mode } from '../config';

const SET_SESSION_USER = 'session/setSessionUser';
const REMOVE_SESSION_USER = 'session/removeSessionUser';

// 토큰 갱신 중복 방지를 위한 변수들
let isRefreshing = false;
let refreshSubscribers = [];

// 토큰 갱신이 완료된 후 대기 중인 요청들을 처리하는 함수
const onRefreshed = (newToken) => {
  refreshSubscribers.forEach(callback => callback(newToken));
  refreshSubscribers = [];
};

// 토큰 갱신 요청을 구독하는 함수
const addRefreshSubscriber = (callback) => {
  refreshSubscribers.push(callback);
};

const setSessionUser = (sessionUser) => ({
  type: SET_SESSION_USER,
  payload: sessionUser,
});

export const removeSessionUser = () => ({
  type: REMOVE_SESSION_USER,
});

/** access/refresh 로컬 저장 및 CMS 다이얼로그 플래그 정리 */
export const clearLocalAuthStorage = (session) => {
  try {
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
  } catch (_) {
    // ignore
  }
  if (session?.id) {
    localStorage.removeItem(`cmsDialogClosed_${session.id}`);
    localStorage.removeItem(`lastLoginTime_${session.id}`);
  } else {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('cmsDialogClosed_') || key.startsWith('lastLoginTime_')) {
        localStorage.removeItem(key);
      }
    });
  }
};

export const initPasswordDirect = async ({ type, bizRegNumber, email, userId }) => {
  // TODO : ~Direct는 dispatch를 null로 실행했는데 이럴 경우 오류 발생시 
  const response = await csrfFetch(null, `${authServerUrl}/api/session/initPassword`, {
    method: "POST",
    body: JSON.stringify({ type, bizRegNumber, email, userId }),
  });

  const data = await response.json();
  return data;
}

export const changePasswordDirect = async ({ credential, type, password, passwordNew, passwordNewConfirm }) => {
  const response = await csrfFetch(null, `${authServerUrl}/api/session/changePassword`, {
    method: "POST",
    body: JSON.stringify({ credential, type, password, passwordNew, passwordNewConfirm }),
  });
  
  const data = await response.json();
  return data;
}

export const login = ({ credential, password, type/*, status*/, searchStatus }) => async dispatch => {
  const response = await csrfFetch(dispatch, `${authServerUrl}/api/session/`, {
    method: "POST",
    body: JSON.stringify({ credential, password, type/*, status*/, searchStatus }),
  });
  
  const data = await response.json();
  
  const { sessionUser, accessToken, refreshToken } = data;
  
  // 중요: redux setGClient 전에 해야함
  sessionStorage.setItem("accessToken", accessToken);
  sessionStorage.setItem("refreshToken", refreshToken);

  dispatch(setSessionUser(sessionUser));
  
  // sessionStorage.setItem("accessToken", accessToken);
  // sessionStorage.setItem("refreshToken", refreshToken);

  return response;
};

// TODO : 추후 type (GLIENT, ADMIN, USER...) 대응 필요
export const setEmailDirect = async ({ type, credential, mailSettings }) => {
  const response = await csrfFetch(null, `${authServerUrl}/api/session/email`, {
    method: "PUT",
    body: JSON.stringify({ type, credential, mailSettings }),
  });
  
  const data = await response.json();
  return data;
}

export const restoreSessionUser = () => async dispatch => {
  try {
    const response = await csrfFetch(dispatch, `${authServerUrl}/api/session/`);
    const data = await response.json();
    // 여러 이유로 세션이 만료되었다고 판단되는 경우 서버에서 {}를 리턴하여 (res.json({} 코드실행) data는 {}이 되고 data.user는 undefined가 됨
    console.log(data.sessionUser)

    // const data = await response.json();
    
    const { sessionUser, accessToken, refreshToken } = data;
    
    if (mode.indexOf('java')) {
    } else {
      // 중요: redux setGClient 전에 해야함
      sessionStorage.setItem("accessToken", accessToken);
      sessionStorage.setItem("refreshToken", refreshToken);
    }

    dispatch(setSessionUser(sessionUser));
    return response;
  } catch (e) {
    console.log("~~~~~~~~~~~~~")
    console.log(e)
  }
};

export const updateSessionUser = (gclient) => dispatch => {
  dispatch(setSessionUser(gclient));
  return;
};

// sessionUser에 정보를 저장해야 하므로 gclient store를 사용하지 않고 session store를 사용함
export const signupGClient = ({ id, name, ceo, bizRegNumber, phone, address, email, password, initPassword, loginCount, /* 판유리협회 회원사 정보 중 추가 컬럼들 */fax, joinDate, products, zipCode, phone2, otherPhones, address2, otherAddresses, membership, consented }) => async (dispatch) => {
  const response = await csrfFetch(dispatch, `${authServerUrl}/api/gclients/signup`, {
    method: "POST",
    body: JSON.stringify({ id, name, ceo, bizRegNumber, phone, address, email, password, initPassword, loginCount, /* 판유리협회 회원사 정보 중 추가 컬럼들 */fax, joinDate, products, zipCode, phone2, otherPhones, address2, otherAddresses, membership, consented }),
  });
  
  const data = await response.json();
  const { sessionUser, accessToken, refreshToken } = data;
  
  sessionStorage.setItem("accessToken", accessToken);
  sessionStorage.setItem("refreshToken", refreshToken);

  dispatch(setSessionUser(sessionUser));

  return response;
};

// sessionUser에 정보를 저장해야 하므로 gclient store를 사용하지 않고 session store를 사용함
export const signupUser = ({ id, userId, name, mobile, password, gclientId, consented }) => async (dispatch) => {
  const response = await csrfFetch(dispatch, `${authServerUrl}/api/users/signup`, {
    method: "POST",
    body: JSON.stringify({ id, userId, name, mobile, password, gclientId, consented }),
  });
  
  const data = await response.json();
  const { sessionUser, accessToken, refreshToken } = data;
  
  sessionStorage.setItem("accessToken", accessToken);
  sessionStorage.setItem("refreshToken", refreshToken);

  dispatch(setSessionUser(sessionUser));

  return response;
};

export const signupUserDirect = async ({
  id,
  userId,
  name,
  mobile,
  password,
  gclientId,
  consented,
  // belongs,
}) => {
  const response = await csrfFetch(null, `${authServerUrl}/api/users/signup`, {
    method: "POST",
    body: JSON.stringify({
      id,
      userId,
      name,
      mobile,
      password,
      gclientId,
      consented,
      // belongs,
    }),
  });

  return response;
};

/**
 * access token 갱신.
 * csrfFetch를 타지 않음 — refresh 실패(11002 등) 시 csrfFetch 11002 재진입/교착 방지.
 * 실패 시 null 반환(대기 중인 subscriber에도 null 전달).
 */
export const refreshAccessToken = async () => {
  if (isRefreshing) {
    return new Promise((resolve) => {
      addRefreshSubscriber((token) => {
        resolve(token);
      });
    });
  }

  isRefreshing = true;
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const xsrf = Cookies.get('XSRF-TOKEN');
    if (xsrf) {
      headers['XSRF-Token'] = xsrf;
    }

    // refresh token 은 HttpOnly cookie (path=/auth/api/session/refreshAccessToken)
    const response = await window.fetch(`${authServerUrl}/api/session/refreshAccessToken`, {
      method: 'POST',
      headers,
      body: JSON.stringify({}),
      credentials: 'include',
    });

    let data = null;
    try {
      data = await response.json();
    } catch (_) {
      data = null;
    }

    const accessToken = data?.accessToken;
    // 401/4xx, 빈 body({}), accessToken 없음 → 모두 세션 종료
    if (!response.ok || !accessToken) {
      clearLocalAuthStorage();
      onRefreshed(null);
      return null;
    }

    sessionStorage.setItem('accessToken', accessToken);
    onRefreshed(accessToken);
    return accessToken;
  } catch (_) {
    clearLocalAuthStorage();
    onRefreshed(null);
    return null;
  } finally {
    isRefreshing = false;
  }
};

export const logout = (session) => async (dispatch) => {
  let response;
  try {
    response = await csrfFetch(dispatch, `${authServerUrl}/api/session/`, {
      method: "DELETE",
    });
  } catch (_) {
    // 만료·네트워크 오류여도 로컬 세션은 반드시 정리
    response = undefined;
  } finally {
    dispatch(removeSessionUser());
    clearLocalAuthStorage(session);
  }

  return response;
};

const initialState = {
  sessionUser: null,
};

function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_SESSION_USER:
      newState = Object.assign({}, state, { sessionUser: action.payload });
      return newState;
    case REMOVE_SESSION_USER:
      newState = Object.assign({}, state, { sessionUser: /*null*/undefined });
      return newState;
    default:
      return state;
  }
}

export default reducer;
